export default "__VITE_ASSET__Bo_dQcdk__"